/*eslint-disable @typescript-eslint/no-explicit-any*/

import { isAxiosError } from 'axios';
import hwaxios from '../../../rmsReduxStore/api-service/HWAxios';
import { acCertificatesTypes } from '../acReduxExports';



const url = process.env.REACT_APP_SERVER_BASE_URL_AC;

export const generateAcChargerCertificates: any = (reqBody: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-certificate-info', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: { messsage: 'Something went wrong' }, status: 400
      }
    }
  }
}

export const pushAcChargerCertificate: any = (reqBody: { certId: string, fileType: string }) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-certificate-info/push-certificate', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      const data = error.response.data;
      const status = error.response.status;
      return { data, status };
    }
    return {
      data: { message: 'Something went wrong' }, status: 400
    }
  }
}

export const setAcChargerCertificatesInfoListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcCertificatesAction>) => void): Promise<void> => {
  const action: Partial<AcCertificatesAction> = {
    type: acCertificatesTypes.SET_AC_CHARGER_CERTIFICATES_INFO_LIST_TABLE_PROPS,
    acChargerCertificatesInfoListTableProps: data,
  };
  dispatch(action);
}

export const fetchAcChargerCertificatesInfoData: any = (reqBody) => async (dispatch: (arg0: Partial<AcCertificatesAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcCertificatesAction> = {
      type: acCertificatesTypes.SET_AC_CERTIFICATES_LOADER,
      loader: true
    }
    dispatch(loaderStartAction);

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
        ? reqBody.searchTerm.trim() : null;
    
    const filterHash = reqBody?.filters;
    
    const hashAction: Partial<AcCertificatesAction> = {
        type: acCertificatesTypes.SET_AC_CHARGER_CERTIFICATES_LIST_REQUEST_HASH,
        acChargerCertificatesInfoListRequestSearchHash: searchHash,
        acChargerCertificatesInfoListRequestFilterHash: filterHash
    };
    dispatch(hashAction);

    const response = await hwaxios.post(url + '/charger-certificate-info/list', reqBody)
    const action: Partial<AcCertificatesAction> = {
      type: acCertificatesTypes.FETCH_AC_CHARGER_CERTIFICATES_INFO_DATA,
      acChargerCertificatesInfo: response.data?.data?.chargerCertificatesInfo,
      acChargerCertificatesInfoCount: response.data?.data?.count,
    }
    dispatch(action)

    if (response?.status === 200) {
      const loaderEndAction: Partial<UsbCertificatesAction> = {
        type: acCertificatesTypes.SET_AC_CERTIFICATES_LOADER,
        loader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<UsbCertificatesAction> = {
        type: acCertificatesTypes.SET_AC_CERTIFICATES_LOADER,
        loader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}